import logo from "./logo.svg";
import "./App.css";
import Header from "./components/header/Header";
import Home from "./components/home/home";
import About from "./components/about/about";
import Skills from "./components/skills/skills";
import Services from "./components/services/Services";
import Qualification from "./components/qualification/Qualification";
import { Testimonial } from "./components/testimonial/Testimonial";
import { Contact } from "./components/contact/Contact";
import { Footer } from "./components/footer/Footer";
import { Scrollup } from "./components/scrollup/Scrollup";
import Project from "./components/project/Project";

function App() {
  return (
    <>
      <Header></Header>
      <main className="main">
        <Home></Home>
        <About></About>
        <Skills />
        {/* <Services></Services> */}
        <Project></Project>
        <Qualification></Qualification>
        {/* <Testimonial></Testimonial> */}
        <Contact></Contact>
      </main>
      <Footer></Footer>
      <Scrollup></Scrollup>
    </>
  );
}

export default App;
